import { CampaignAPI } from "generated-api"
import { checkIfSessionIsOrWillExpired } from "user/tools/common"
import { CAP_PERIODS, ICap, ICapDTO, ICapRepository } from "./model"

export const capRPO: ICapRepository = {
  getCaps(campaignId: number): Promise<ICap[]> {
    return new Promise<ICap[]>((resolve, reject) => {
      try {
        checkIfSessionIsOrWillExpired()
        CampaignAPI.getApiCampaignCapList(campaignId)
          .then(response => resolve(response.map(c => getCapFromRaw(c))))
          .catch((error: any) => {
            console.error("Server error while getting all caps", error)
            reject("cap.get.error.server")
          })
      } catch (ex) {
        console.error("Unexpected error while getting cap", ex)
        reject("cap.get.error.unexpected")
      }
    })
  },
  createCap(campaignId: number, cap: ICap): Promise<ICap> {
    return new Promise<ICap>((resolve, reject) => {
      try {
        checkIfSessionIsOrWillExpired()
        CampaignAPI.postApiCampaignCap({
          campaign_id: campaignId,
          frequency: cap.frequency,
          units: cap.units,
          period: cap.period as any
        })
          .then(response => resolve(getCapFromRaw(response, cap.period)))
          .catch((error: any) => {
            console.error("Server error while creating cap", error)
            reject("cap.add.error.server")
          })
      } catch (ex) {
        console.error("Unexpected error while creating cap", ex)
        reject("cap.add.error.unexpected")
      }
    })
  },
  updateCap(campaignId: number, cap: ICap): Promise<ICap> {
    return new Promise<ICap>((resolve, reject) => {
      try {
        checkIfSessionIsOrWillExpired()
        CampaignAPI.putApiCampaignCap({
          campaign_id: campaignId,
          id: cap.id,
          frequency: cap.frequency,
          units: cap.units,
          period: cap.period as any
        })
          .then(response => resolve(getCapFromRaw(response, cap.period)))
          .catch((error: any) => {
            console.error("Server error while updating cap", error)
            reject("cap.update.error.server")
          })
      } catch (ex) {
        console.error("Unexpected error while updating cap", ex)
        reject("cap.update.error.unexpected")
      }
    })
  },
  deleteCap(campaignId: number, capId: number): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      try {
        checkIfSessionIsOrWillExpired()
        CampaignAPI.deleteApiCampaignCap(campaignId, capId)
          .then(() => resolve())
          .catch((error: any) => {
            console.error("Server error while deleting cap", error)
            reject("cap.delete.error.server")
          })
      } catch (ex) {
        console.error("Unexpected error while deleting cap", ex)
        reject("cap.delete.error.unexpected")
      }
    })
  }
}

function getCapFromRaw(capDTO: ICapDTO, period?: CAP_PERIODS): ICap {
  return {
    ...capDTO,
    period: period
      ? period
      : typeof capDTO.period === "number"
      ? getPeriodFromSecondCount(capDTO.period)
      : (capDTO.period as CAP_PERIODS)
  }
}

function getPeriodFromSecondCount(seconds: number): CAP_PERIODS {
  switch (seconds) {
    /* case 1: {
      return CAP_PERIODS.SECOND
    } */
    case 2626560: {
      // 30,4 day per month
      return CAP_PERIODS.MONTH
    }
    case 604800: {
      return CAP_PERIODS.WEEK
    }
    case 86400: {
      return CAP_PERIODS.DAY
    }
    case 3600: {
      return CAP_PERIODS.HOUR
    }
    case 60: {
      return CAP_PERIODS.MINUTE
    }
    default: {
      return CAP_PERIODS.MINUTE
      // return CAP_PERIODS.CAMPAIGN
    }
  }
}
